<script setup>
import ToggleQuotationToCallAction from "@frontJs/components/actions/projectManagement/apikom/ToggleQuotationToCallAction.vue";
import { BellAlertIcon, BellIcon, PencilIcon } from "@heroicons/vue/24/outline";
import ActionButton from "@js/components/ActionButton.vue";
import { useRoute } from "@js/utils/route";
import { toast } from "vue3-toastify";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const { row, callback } = defineProps({
  row: {
    type: Object,
    required: true,
  },
  callback: {
    type: Function,
    required: true,
  },
});

const { route } = useRoute();

function saveActionCallback() {
  toast.success(t("toast.successfullySaved"), { position: "top-right" });
  callback();
}
</script>

<template>
  <div class="flex h-full items-center gap-2 p-4">
    <ToggleQuotationToCallAction
      :quotation="row.original"
      :callback="saveActionCallback"
    >
      <template #button="{ action }">
        <ActionButton
          size="small"
          type="secondary"
          class="size-8"
          :callback="() => action()"
          :title="
            row.original.toCall
              ? t('button.notHasToCall')
              : t('button.hasToCall')
          "
        >
          <BellIcon v-if="row.original.toCall" class="size-5 flex-shrink-0" />
          <BellAlertIcon v-else class="size-5 flex-shrink-0" />
        </ActionButton>
      </template>
    </ToggleQuotationToCallAction>

    <ActionButton
      size="small"
      class="size-8"
      :title="t('button.edit')"
      :href="
        route('front.projectManagement.apikom.updateQuotation', {
          quotation: row.original.id,
        })
      "
      :icon="PencilIcon"
    />
  </div>
</template>
